import BusinessLandingModule from './containers/businessLandingModule'

export {default as BusinessLandingModuleLayout} from './components/businessLandingModuleLayout'

export default BusinessLandingModule
